import { render, staticRenderFns } from "./SelectPointDialog.vue?vue&type=template&id=2d3835e2&scoped=true&"
import script from "./SelectPointDialog.vue?vue&type=script&lang=js&"
export * from "./SelectPointDialog.vue?vue&type=script&lang=js&"
import style0 from "./SelectPointDialog.vue?vue&type=style&index=0&id=2d3835e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3835e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
